<template>
  <el-dialog
    :title="title"
    :visible.sync="show"
    :center="true"
    width="800px"
    :modal="false"
    :close-on-click-modal="false"
    v-loading="loading">
    <div >
      <div>
        <el-form :inline="true" label-width="80px">
          <el-form-item label="服务名称" style="width: 230px">
            <el-input v-model="serveName" placeholder="请输入服务名称" style="width: 150px" clearable @change="initServePage"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="initServePage" >查询</el-button>
          </el-form-item>
        </el-form>
        <el-table class="w100 mt20 table" header-row-class-name="table-head"
          row-class-name="cu-p" stripe :data="list" height="300px">
          <el-table-column align="center" label="序号" width="50px" type="index"></el-table-column>
          <el-table-column align="center" prop="serveName" label="服务名称"></el-table-column>
          <el-table-column align="center"  prop="createTime" label="创建时间" width="180px"></el-table-column>
          <el-table-column align="center" prop="username" label="创建人"></el-table-column>
          <el-table-column label="操作" width="100" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="selectServer(scope.row)"
              >选择
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="mt20 flex-box">
        <div class="flex-1"></div>
        <el-pagination 
          background 
          @current-change="changePage"
          :current-page="current"
          :page-size="size"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getServePage } from '@/api/managementCenter/serveManage';

export default {
  name: "serverSelect",
  components: {
  },
  props: [],
  data() {
    return {
      loading: false,
      show: false,
      title: '选择服务',
      current: 1,
      size: 10,
      total: 0,
      list: [],
      serveName: '',
    };
  },
  computed: {},
  created() {},
  mounted() {
  },
  destroyed() {},
  methods: {
    dialogShow () {
      this.show = true;
      this.initServePage();
    },
    initServePage(){
      this.current = 1;
      this.getServePage()
    },
    getServePage(){
      this.loading = true;
      let params = {
        current: this.current,
        size: this.size,
        serveName: this.serveName,
      }
      getServePage(params)
      .then(({data}) => {
        this.loading = false;
        if(data.code == 0){
          this.list = data.data.records || []
          this.total = data.data.total;
        }else {
          this.$message.error(data.msg)
        }
      })
      .finally(() => {
        this.loading = false;
      })
    },
    changePage(val){
      this.current = val;
      this.getServePage()
    },
    selectServer(row){
      this.$emit("closeServerSelect", row);
      this.show = false;
    }
  },
  watch: {},
  filters: {}
};
</script>

<style scoped>
</style>
